export const EVENT_LOCATIONS = {
  mayo1: {
    address1: "Saint Marys Campus",
    address2: "Nasseff Tower / Alfred Desk 1E",
  },
  mayo2: {
    address1: "Saint Marys Campus",
    address2: "Admission And Business Office",
  },
  mayo3: {
    address1: "Saint Marys Campus",
    address2: "Mary Brigh Desk 4D",
  },
  mayo4: null
}